import * as React from "react";

import { Checkbox } from "@graffer-inc/console-design-kit";
import { displayName, Roles } from "../../../application/domain/rbac/rbac";

export type UserRolesSelectorProps = {
  label?: string; // TODO(hirata): ユーザー作成画面のformikを剥がせたら、必須化してGCDKの見た目にする
  required?: boolean;
  values: Roles[];
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  errorMessages: string | string[] | undefined;
  canSelectAdmin?: boolean;
  shouldDisplayError?: boolean;
};

export const UserRolesSelector: React.FC<UserRolesSelectorProps> = ({
  label = "",
  required = false,
  values,
  onChange,
  errorMessages,
  canSelectAdmin = false,
  shouldDisplayError,
}) => {
  const SYSTEM_LEVEL_ROLE_CANDIDATES = [
    {
      value: "Staff",
      name: displayName("Staff"),
      description: "各サービスの利用に必要な権限が付与されます。",
    },
    {
      value: "AccountManager",
      name: displayName("AccountManager"),
      description:
        "ユーザー作成・更新など、アカウント管理に必要な権限が付与されます。",
    },
  ];
  const SYSTEM_LEVEL_ROLE_CANDIDATES_INCLUDING_ADMIN = [
    {
      value: "Admin",
      name: displayName("Admin"),
      description: "全ての権限が付与されます。",
    },
    ...SYSTEM_LEVEL_ROLE_CANDIDATES,
  ];
  return (
    <Checkbox
      label={label}
      required={required}
      description=""
      values={values}
      options={
        canSelectAdmin
          ? SYSTEM_LEVEL_ROLE_CANDIDATES_INCLUDING_ADMIN
          : SYSTEM_LEVEL_ROLE_CANDIDATES
      }
      onChange={onChange}
      errorMessages={errorMessages}
      shouldDisplayError={shouldDisplayError}
    />
  );
};
